import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import FormHelperText from "@mui/material/FormHelperText";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./selectMenu.scss"; // Ensure the styles exist
import commonImages from "../../../assets";
import selectIcon from "./selectmenuIcon";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import "./multiSelectDrag.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultiSelectDrag = ({
  listData = [],
  onChange,
  value = [],
  name = "",
  isIdShow = false,
  isError = false,
  errorMessage = "Required",
}) => {
  const handleChange = (event) => {
    const { value: selectedItems } = event.target;
    const updatedValues = listData.filter((item) =>
      selectedItems.some((selected) => selected?.key === item?.key)
    );

    onChange({ target: { name, value: updatedValues } });
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = Array.from(value);
    const [movedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, movedItem);
    onChange({ target: { name, value: reorderedItems } });
  };

  const handleRemove = (itemKey) => {
    const updatedValues = value.filter((item) => item.key !== itemKey);
    onChange({ target: { name, value: updatedValues } });
  };

  return (
    <div className="overideSelectMenu">
      <Select
        multiple
        value={value}
        onChange={handleChange}
        size="small"
        renderValue={(selected) =>
          selected?.map((x) => x?.value).join(", ") || ""
        }
        MenuProps={MenuProps}
        className="selectBox"
        name={name}
        IconComponent={selectIcon}
      >
        {listData.map((variant) => (
          <MenuItem key={variant.key} value={variant}>
            <img
              className="multiCheck"
              title={
                value.some((item) => item?.key === variant?.key)
                  ? "tickCheckbox"
                  : "untickCheckbox"
              }
              alt=""
              src={
                value.some((item) => item?.key === variant?.key)
                  ? commonImages.check
                  : commonImages.noCheck
              }
            />
            <ListItemText>
              {variant.value} {isIdShow && `(${variant.key})`}
            </ListItemText>
          </MenuItem>
        ))}
      </Select>
      {value?.length > 0 && <div className="dragTitle">Added Lessons</div>}

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="selected-items" type="LIST">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {value.map((selectedItem, index) => (
                <Draggable
                  key={selectedItem?.key?.toString()}
                  draggableId={selectedItem?.key?.toString()}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="draggable-item selectDragItem"
                    >
                      <div className="dragIcon">
                        <DragIndicatorIcon />
                      </div>
                      <ListItemText>
                        {selectedItem.value}{" "}
                        {isIdShow && `(${selectedItem.key})`}
                      </ListItemText>
                      <div
                        className="removeItem"
                        onClick={() => handleRemove(selectedItem.key)}
                      >
                        X
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {/* Error Message */}
      {isError && value.length === 0 && (
        <FormHelperText className="errorText">{errorMessage}</FormHelperText>
      )}
    </div>
  );
};

export default MultiSelectDrag;
